export default __webpack_public_path__ + "static/spotlight-anatomy-dark-29a6bb0823e1b1ad71edb97b5e8b2eecf8ed4d19ce94c7ed8923eeda33e408d8.png";